const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    containerized,
    margin,
    contentPosition,
    variant,
    background,
    sideImage,
    withFigcaption,
    figcaption,
    imagePosition,
    titleFull,
    titleAfterImage,
    padding,
  } = attributes;

  return (
    <section className={`ImageWithTopics ${margin} ${variant} ${background} `}>
      <div
        className={`${
          containerized ? 'Container' : ''
        } Container-block-pd-${padding}`}
      >
        <div
          className={`ImageWithTopics__content ${contentPosition} ${
            titleFull && 'title-full'
          } ${titleAfterImage && 'title-after'} `}
        >
          {sideImage.src && (
            <figure
              className={`ImageWithTopics__content--img ${contentPosition} ${imagePosition}`}
            >
              <img
                src={sideImage.src}
                alt={sideImage.alt}
                height={sideImage.height}
              />

              {withFigcaption && (
                <RichText.Content
                  tagName="figcaption"
                  className={`Typography text left color-black margin-none`}
                  value={figcaption}
                />
              )}
            </figure>
          )}

          <InnerBlocks.Content />
        </div>
      </div>
    </section>
  );
};

export default Save;
